import { PropsWithChildren } from "react"
import PopupContainer from "src/component/popup/PopupContainer"
import { useTranslation } from "react-i18next"
import { Icon } from "@iconify/react"
import "./SummaryPopup.css"

const ConfirmationModalName = "revise-order"

interface IConfirmationModal {
    headerItems?: Record<string, string | number>
    items: Record<string, string | number>[]
    modalID: any
    onConfirm?: () => void
    onCancel?: () => void
    isLoading?: boolean,
    summaryTableTitle: string
}

export const SummaryPopup = ({ modalID, headerItems, items, onConfirm, onCancel, isLoading = false, summaryTableTitle }: PropsWithChildren<IConfirmationModal>) => {
    const { t } = useTranslation()

    return (
        <PopupContainer Name={ConfirmationModalName} modalID={modalID} modalName={ConfirmationModalName}>
            <div className="confirm-modal">
                {headerItems && (
                    <div className="confirm-summary">
                        {Object.entries(headerItems).map(([key, value]) => (
                            <div key={key} className="confirm-summary-item">
                                <span className="confirm-summary-label">{t(key)}</span>
                                <span className="confirm-summary-value">{value}</span>
                            </div>
                        ))}
                    </div>
                )}

                {items && items.length > 0 && (
                    <div className="confirm-list">
                        <div className="confirm-list-header">
                            {t(summaryTableTitle)}
                        </div>
                        <div className="confirm-list-body">
                            {items.map((item: any, index) => (
                                <div key={index} className="confirm-list-item">
                                    {item.name &&
                                        <span className="confirm-item-name">
                                            {t(String(item.name))}
                                        </span>}
                                    <span className="confirm-item-value">
                                        {item.value}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {(onConfirm || onCancel) && (
                    <div className="confirm-actions">
                        {onCancel && (
                            <button
                                className="confirm-btn confirm-btn-secondary"
                                onClick={onCancel}
                                disabled={isLoading}
                            >
                                {t("back")}
                            </button>
                        )}
                        {onConfirm && (
                            <button
                                className="confirm-btn confirm-btn-primary"
                                onClick={onConfirm}
                                disabled={isLoading || items.length === 0}
                            >
                                {isLoading && (
                                    <Icon icon="line-md:loading-loop" className="confirm-btn-loader" />
                                )}
                                {t("confirm")}
                            </button>
                        )}
                    </div>
                )}
            </div>
        </PopupContainer>
    )
}